<template>
    <div class="local-gps-container bg-white">
    <template v-if="localTieneGPS">
      <div class="w-full h-full flex flex-col">
        <div class="gps-header flex items-center justify-between p-4">
            <div class="flex items-center space-x-3">
                <div class="flex items-center justify-center w-10 h-10 bg-white rounded-xl">
                <svg class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
                </div>
                <div>
                <p class="text-xs text-gray-600 font-medium">
                    <span class="text-blue-600">{{ nombreEmpresa || 'Empresa' }}</span> • 
                    <span class="text-gray-500">GPS Obtenido gracias a </span>
                    <span class="text-indigo-600 font-semibold">Efibox</span>
                </p>
                </div>
            </div>
          <div class="flex items-center space-x-2">
            <button 
              @click="refrescarGPS"
              :disabled="estadoGPS === 'cargando'"
              class="p-1 text-gray-400 hover:text-gray-600 disabled:opacity-50 rounded"
              title="Refrescar GPS"
            >
              <svg :class="['w-4 h-4', estadoGPS === 'cargando' ? 'animate-spin' : '']" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
              </svg>
            </button>
          </div>
        </div>
        
        <div class="gps-map-container flex-1 relative">
          <iframe
            v-if="urlMapa"
            :key="`gps-${localId}-${reloadKey}`"
            :src="urlMapa"
            width="100%" 
            height="100%"
            style="border: none;" 
            allowfullscreen
            loading="lazy"
            class="w-full h-full"
            @load="onMapaCargado"
            @error="onMapaError"
          ></iframe>
          <div 
            v-if="estadoGPS === 'cargando'" 
            class="absolute inset-0 bg-white flex items-center justify-center z-10"
          >
            <div class="text-center">
              <div class="relative mb-4">
                <div class="w-12 h-12 rounded-full animate-spin mx-auto"></div>
                <div class="absolute inset-0 flex items-center justify-center">
                  <div class="w-6 h-6 bg-blue-600 rounded-full animate-ping opacity-30"></div>
                </div>
              </div>
              <p class="text-sm font-medium text-gray-700 mb-1">Cargando ubicación GPS</p>
              <p class="text-xs text-gray-500 max-w-xs truncate">{{ direccion }}</p>
            </div>
          </div>
          <div v-if="estadoGPS === 'error'" class="absolute inset-0 bg-red-50 flex items-center justify-center z-10 border border-red-200">
            <div class="text-center p-6">
              <svg class="w-16 h-16 text-red-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <h3 class="text-red-700 font-semibold mb-2">Error cargando GPS</h3>
              <p class="text-red-600 text-sm mb-4 max-w-xs">
                {{ errorMensaje || 'No se pudo cargar la ubicación en el mapa' }}
              </p>
              <button @click="refrescarGPS" class="bg-red-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-red-700 transition-colors">
                Intentar de nuevo
              </button>
            </div>
          </div>
          <div v-if="!urlMapa && estadoGPS !== 'cargando'" class="absolute inset-0 bg-gray-50 flex items-center justify-center">
            <div class="text-center">
              <svg class="w-12 h-12 text-gray-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
              </svg>
              <p class="text-sm text-gray-500">Preparando mapa...</p>
            </div>
          </div>
        </div>
        
        <div class="gps-info-panel px-4 py-3">
            <div class="flex items-center space-x-2 text-sm text-gray-600">
                <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
                <div>
                    {{ this.direccionFinal }}
                </div>
            </div>   
          <div class="flex items-center justify-between">
            <div class="flex items-center space-x-4">
              <button 
                @click="copiarDireccion"
                class="flex items-center space-x-1 text-xs text-blue-600 hover:text-blue-800 transition-colors"
                title="Copiar dirección"
              >
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
                </svg>
                <span>Copiar</span>
              </button>
              
              <button 
                @click="compartirUbicacion" class="flex items-center space-x-1 text-xs text-blue-600 hover:text-blue-800 transition-colors" title="Compartir ubicación">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"></path>
                </svg>
                <span>Compartir</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    
    <template v-else-if="localSinDireccion">
      <div class="flex flex-col items-center justify-center p-8 h-64 bg-gradient-to-br from-yellow-50 to-orange-50 border border-yellow-200 rounded-lg">
        <svg class="w-16 h-16 text-yellow-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" 
                d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <h3 class="text-lg font-semibold text-yellow-800 mb-2">Local sin ubicación GPS</h3>
        <p class="text-yellow-700 text-center mb-4 max-w-sm leading-relaxed">
          El <strong>Local N° {{ numeroLocal || 'seleccionado' }}</strong> no tiene una dirección registrada para mostrar en el mapa.
        </p>
        <div class="text-center space-y-3">
          <p class="text-sm text-yellow-600">Para activar el GPS automático:</p>
          <div class="flex flex-col sm:flex-row gap-2">
            <button @click="solicitarEdicionLocal" class="bg-yellow-600 text-white px-4 py-2 rounded-lg hover:bg-yellow-700 transition-colors text-sm font-medium">
              Agregar dirección al local
            </button>
            <button @click="solicitarAyuda" class="bg-white text-yellow-700 border border-yellow-300 px-4 py-2 rounded-lg hover:bg-yellow-50 transition-colors text-sm">
              ¿Cómo agregar dirección?
            </button>
          </div>
        </div>
      </div>
    </template>
    
    <template v-else>
      <div class="flex flex-col items-center justify-center p-8 h-64">
        <svg class="w-16 h-16 text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
        </svg>
        <h3 class="text-lg font-medium text-gray-700 mb-2">Selecciona un local</h3>
        <p class="text-gray-500 text-center max-w-sm leading-relaxed">
          Elige un local de la lista para ver automáticamente su ubicación GPS en Google Maps.
        </p>
        
        <div v-if="nombreEmpresa" class="mt-4 text-center p-3 bg-blue-50 rounded-lg border border-blue-200">
          <p class="text-xs text-blue-600 font-medium">{{ nombreEmpresa }}</p>
          <p class="text-xs text-blue-500 mt-1">Empresa seleccionada • GPS listo para activarse</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'LocalGPS',
  props: {
    // Datos del local
    local: {
      type: Object,
      default: null
    },
    direccion: {
      type: String,
      default: ''
    },
    numeroLocal: {
      type: [String, Number],
      default: null
    },
    localId: {
      type: [String, Number],
      default: null
    },
    
    // Datos de contexto
    nombreEmpresa: {
      type: String,
      default: ''
    },
    
    // Configuración del componente
    altura: {
      type: String,
      default: '300px'
    },
    permitirEdicion: {
      type: Boolean,
      default: true
    },
    autoCargar: {
      type: Boolean,
      default: true
    },
    
    // Configuración avanzada
    zoomLevel: {
      type: String,
      default: '18'
    },
    tipoMapa: {
      type: String,
      default: 'k', // 'm' = mapa, 'k' = satélite, 'h' = híbrido
      validator: value => ['m', 'k', 'h'].includes(value)
    }
  },
  
  // EVENTS - Lo que el componente puede emitir
  emits: [
    'gps-loaded',      // Cuando el GPS se carga exitosamente
    'gps-error',       // Cuando hay error cargando GPS
    'location-shared', // Cuando se comparte la ubicación
    'edit-requested',  // Cuando se solicita editar el local
    'help-requested',  // Cuando se solicita ayuda
    'gps-refreshed'    // Cuando se refresca el GPS manualmente
  ],
  
  // DATA - Estado interno del componente
  data() {
    return {
      // Estado del GPS
      estadoGPS: 'inicial', // 'inicial', 'cargando', 'listo', 'error'
      errorMensaje: null,
      timestampActualizacion: null,
      reloadKey: 0,
      
      // Control de carga
      timerCarga: null,
      tiempoMaximoCarga: 10000, // 10 segundos máximo
    }
  },
  
  // COMPUTED - Propiedades calculadas
  computed: {
    /**
     * DETECTA si el local tiene GPS válido
     */
    localTieneGPS() {
      return !!(this.direccionFinal && this.direccionFinal.trim().length > 0)
    },
    
    /**
     * DETECTA si hay local pero sin dirección
     */
    localSinDireccion() {
      return !!(this.localIdFinal && !this.localTieneGPS)
    },
    
    /**
     * 📍 DIRECCIÓN final (con fallbacks)
     */
    direccionFinal() {
      return this.direccion || this.local?.direccion || ''
    },
    
    /**
     * 🏪 ID del local final
     */
    localIdFinal() {
      return this.localId || this.local?.id || null
    },
    
    /**
     * 🗺️ URL automática del mapa
     */
    urlMapa() {
      if (!this.localTieneGPS) return null
      
      const params = {
        q: this.direccionFinal.trim(),
        hl: 'es',
        z: this.zoomLevel,
        output: 'embed',
        t: this.tipoMapa,
        reload: this.reloadKey
      }
      
      const queryString = Object.entries(params)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&')
      
      return `https://maps.google.com/maps?${queryString}`
    },
    
    /**
     * 🌍 URL para Google Maps externo
     */
    urlGoogleMapsExterno() {
      if (!this.localTieneGPS) return null
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.direccionFinal)}`
    },
    
    /**
     * 📊 Texto del estado actual
     */
    textoEstado() {
      const estados = {
        inicial: 'Iniciando',
        cargando: 'Cargando',
        listo: 'Activo',
        error: 'Error'
      }
      return estados[this.estadoGPS] || 'Desconocido'
    },
    
    /**
     * 📊 Texto del estado detallado
     */
    textoEstadoDetallado() {
      switch (this.estadoGPS) {
        case 'inicial':
          return 'Preparando GPS...'
        case 'cargando':
          return 'Conectando con Google Maps...'
        case 'listo':
          return `GPS activo • ${this.timestampActualizacion || 'Ahora'}`
        case 'error':
          return 'Error de conexión'
        default:
          return 'Estado desconocido'
      }
    }
  },
  
  // WATCHERS - Reactividad automática
  watch: {
    /**
     * WATCHER CRÍTICO: Detecta cambios en la dirección
     */
    direccionFinal: {
      handler(nuevaDireccion, direccionAnterior) {
        
        if (nuevaDireccion && nuevaDireccion !== direccionAnterior) {
          if (this.autoCargar) {
            this.iniciarCargaAutomatica()
          }
        } else if (!nuevaDireccion) {
          this.resetearEstado()
        }
      },
      immediate: true // ¡CRÍTICO! Se ejecuta al montar
    },
    
    /**
     * WATCHER para cambios de local ID
     */
    localIdFinal: {
      handler(nuevoId, idAnterior) {
        if (nuevoId && nuevoId !== idAnterior) {
          this.reloadKey = Date.now()
          this.resetearEstado()
        }
      }
    }
  },
  
  // METHODS - Funcionalidades del componente
  methods: {
    /**
     * INICIAR CARGA AUTOMÁTICA
     */
    iniciarCargaAutomatica() {
      
      // Limpiar timer anterior si existe
      if (this.timerCarga) {
        clearTimeout(this.timerCarga)
      }
      
      this.estadoGPS = 'cargando'
      this.errorMensaje = null
      this.timestampActualizacion = null
      
      // Timer de timeout por si el mapa no carga
      this.timerCarga = setTimeout(() => {
        if (this.estadoGPS === 'cargando') {
          this.estadoGPS = 'error'
          this.errorMensaje = 'Tiempo de carga agotado'
          this.$emit('gps-error', this.errorMensaje)
        }
      }, this.tiempoMaximoCarga)
    },
    
    /**
     * CALLBACK: Mapa cargado exitosamente
     */
    onMapaCargado() {
      
      if (this.timerCarga) {
        clearTimeout(this.timerCarga)
      }
      
      this.estadoGPS = 'listo'
      this.errorMensaje = null
      this.timestampActualizacion = new Date().toLocaleTimeString('es-CL', {
        hour: '2-digit',
        minute: '2-digit'
      })
      
      // Emitir evento de éxito
      this.$emit('gps-loaded', {
        direccion: this.direccionFinal,
        local: this.localIdFinal,
        timestamp: this.timestampActualizacion
      })
    },
    
    /**
     * CALLBACK: Error cargando mapa
     */
    onMapaError(event) {
      console.error('[LocalGPS] Error cargando mapa:', event)
      
      if (this.timerCarga) {
        clearTimeout(this.timerCarga)
      }
      
      this.estadoGPS = 'error'
      this.errorMensaje = 'Error cargando Google Maps'
      
      // Emitir evento de error
      this.$emit('gps-error', {
        error: this.errorMensaje,
        direccion: this.direccionFinal,
        local: this.localIdFinal
      })
    },
    
    /**
     * REFRESCAR GPS manualmente
     */
    refrescarGPS() {
      
      this.reloadKey = Date.now()
      this.resetearEstado()
      
      if (this.localTieneGPS) {
        this.iniciarCargaAutomatica()
      }
      
      this.$emit('gps-refreshed', {
        direccion: this.direccionFinal,
        timestamp: new Date().toISOString()
      })
    },
    
    /**
     * RESETEAR estado del componente
     */
    resetearEstado() {
      if (this.timerCarga) {
        clearTimeout(this.timerCarga)
      }
      
      this.estadoGPS = 'inicial'
      this.errorMensaje = null
      this.timestampActualizacion = null
    },
    
    /**
     * ABRIR en Google Maps externo
     */
    abrirEnGoogleMaps() {
      if (this.urlGoogleMapsExterno) {
        window.open(this.urlGoogleMapsExterno, '_blank')
      }
    },
    
    /**
     * COPIAR dirección
     */
    async copiarDireccion() {
      if (!this.direccionFinal) return
      
      const textoCompleto = `${this.direccionFinal}\n${this.nombreEmpresa || 'Empresa'}`
      
      try {
        await navigator.clipboard.writeText(textoCompleto)
        this.mostrarNotificacion('Dirección copiada', 'success')
      } catch (error) {
        this.mostrarNotificacion('Error al copiar', 'error')
      }
    },
    
    /**
     * COMPARTIR ubicación
     */
    async compartirUbicacion() {
      if (!this.direccionFinal) return
      
      const datosCompartir = {
        title: `Local N° ${this.numeroLocal || 'N/A'}`,
        text: `${this.direccionFinal} - ${this.nombreEmpresa || 'Empresa'}`,
        url: this.urlGoogleMapsExterno
      }
      
      try {
        if (navigator.share) {
          await navigator.share(datosCompartir)
        } else {
          // Fallback: WhatsApp
          const textoWhatsApp = encodeURIComponent(`${datosCompartir.text}\n${datosCompartir.url}`)
          window.open(`https://wa.me/?text=${textoWhatsApp}`, '_blank')
        }
        
        this.$emit('location-shared', datosCompartir)
      } catch (error) {
        this.mostrarNotificacion('Error al compartir', 'error')
      }
    },
    
    /**
     * SOLICITAR edición del local
     */
    solicitarEdicionLocal() {
      
      this.$emit('edit-requested', {
        localId: this.localIdFinal,
        numeroLocal: this.numeroLocal,
        direccionActual: this.direccionFinal
      })
    },
    
    /**
     * SOLICITAR ayuda
     */
    solicitarAyuda() {
      
      this.$emit('help-requested', {
        localId: this.localIdFinal,
        numeroLocal: this.numeroLocal
      })
    },
    
    /**
     * MOSTRAR notificación temporal
     */
    mostrarNotificacion(mensaje, tipo = 'info') {
      const colores = {
        success: 'bg-green-600 text-white',
        error: 'bg-red-600 text-white',
        info: 'bg-blue-600 text-white'
      }
      
      const notif = document.createElement('div')
      notif.textContent = mensaje
      notif.className = `fixed bottom-4 right-4 ${colores[tipo]} px-4 py-2 rounded-lg text-sm font-medium shadow-lg z-50 transform transition-all duration-300`
      
      document.body.appendChild(notif)
      
      setTimeout(() => {
        notif.style.transform = 'translateX(100%)'
        notif.style.opacity = '0'
        setTimeout(() => {
          if (document.body.contains(notif)) {
            document.body.removeChild(notif)
          }
        }, 300)
      }, 3000)
    }
  },
  
  // LIFECYCLE - Limpieza al desmontar
  beforeUnmount() {
    if (this.timerCarga) {
      clearTimeout(this.timerCarga)
    }
  }
}
</script>

<style scoped>
.local-gps-container {
  min-height: 300px;
}

.gps-map-container {
  background: #f9fafb;
}

/* Animaciones suaves */
.transition-all {
  transition: all 0.3s ease;
}

/* Efectos hover mejorados */
button:hover {
  transform: translateY(-1px);
}

button:active {
  transform: translateY(0);
}

/* Responsive */
@media (max-width: 640px) {
  .gps-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  
  .gps-info-panel {
    padding: 1rem;
  }
}
</style>